import cartaoGoldHorizontal from 'assets/images/cartoes/cartaoGoldHorizontal.svg'
import cartaoGoldAthleticoPrVetical from 'assets/images/cartoes/cartaoGoldAthleticoPrVertical.svg'

export const cartoesModelos = {
  GOLD: cartaoGoldHorizontal,
  ATHLETICO: cartaoGoldAthleticoPrVetical,
  FORTALEZA: cartaoGoldHorizontal,
  VIRTUAL_KIDS: cartaoGoldHorizontal,
}
